import { call, fork, takeEvery, put } from 'redux-saga/effects';
import { logDmbErrorLocation } from '../utils/error';
import { olConnectionV1 } from '../requesters/olConnection';
import {
  getFieldRegionReport
} from '../queries/fieldRegionReportQuery';
import {
  getFieldRegionReportWithApplicationStats
} from '../queries/fieldRegionReportQueryWithApplicationStats';
import {
  receiveRegionReport,
  failureRegionReport,
  receiveValidateRegion,
  failureValidateRegion,
  receiveRegionReportApplicationEvent,
  failureRegionReportApplicationEvent
} from '../actions/regionActions';
import {
  REQUEST_REGION_REPORT_APPLICATION_EVENT,
  REQUEST_REGION_REPORT,
  REQUEST_VALIDATE_REGION,
} from '../constants/actionTypes';
import { isRegionInsideField } from '../utils/regionUtils';
import { trackEvent } from '../actions/analyticsActions';
import { getFieldRegionReportApplicationEvents } from '../queries/fieldRegionReportApplicationEventsQuery';

export function* fetchRegionReport(action) {
  try {
    const { fieldUUID, seasonTag, geometry, includesAsAppliedApplicationData } = action.payload;
    let query;

    if(includesAsAppliedApplicationData) {
      query = getFieldRegionReportWithApplicationStats(
        fieldUUID, seasonTag, geometry, includesAsAppliedApplicationData
      ); 
    } else {
      query = getFieldRegionReport(fieldUUID, seasonTag, geometry);
    }
    
    const response = yield call(olConnectionV1, query);
    yield put(receiveRegionReport(response.data.reports.fieldRegionReport));
    yield put(
      trackEvent('field_region_report', 'viewed', {
        shape: geometry.type,
      })
    );
  } catch (error) {
    logDmbErrorLocation(error, 'Fetch Field Region Report');
    yield put(failureRegionReport());
  }
}

export function* fetchRegionReportApplicationEvent(action) {
  try{
    const applicationEventParams = action.payload;

    const query = getFieldRegionReportApplicationEvents( applicationEventParams )
    
    const response = yield call(olConnectionV1, query);
    yield put(receiveRegionReportApplicationEvent(response.data.reports.fieldRegionReportApplicationEvents));
    yield put(
      trackEvent('field_region_report_application_event', 'viewed', {
        shape: applicationEventParams.geometry.type,
      })
    );
  } catch (error) {
    logDmbErrorLocation(error, 'Fetch Application Event')
    yield put(failureRegionReportApplicationEvent());
  }
}

export function* validateRegion(action) {
  try {
    const { fieldBoundary, region } = action;
    const isRegionValid = yield call(
      isRegionInsideField,
      fieldBoundary,
      region
    );
    yield put(receiveValidateRegion(isRegionValid));
  } catch (error) {
    logDmbErrorLocation(error, 'Validate Region');
    yield put(failureValidateRegion());
  }
}

export function* getRegionReportWatcher() {
  yield takeEvery(REQUEST_REGION_REPORT, fetchRegionReport);
}

export function* getRegionReportApplicationEventWatcher() {
  yield takeEvery(REQUEST_REGION_REPORT_APPLICATION_EVENT, fetchRegionReportApplicationEvent);
}

export function* validateRegionWatcher() {
  yield takeEvery(REQUEST_VALIDATE_REGION, validateRegion);
}

export default function* rootSaga() {
  yield fork(getRegionReportWatcher);
  yield fork(getRegionReportApplicationEventWatcher);
  yield fork(validateRegionWatcher);
}
